import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon"]

  toggle() {
    this.contentTarget.classList.toggle("hidden")
    
    // Rotate icon - check if it's a caret-down (should rotate 180deg) or other icons (90deg)
    const isCaretDown = this.iconTarget.getAttribute("icon")?.includes("caret-down")
    const rotationDegrees = isCaretDown ? "180deg" : "90deg"
    
    this.iconTarget.style.transform = this.contentTarget.classList.contains("hidden") ? "" : `rotate(${rotationDegrees})`
  }
} 